'use strict';
export default (val) => `${val}`.replace(/[^\d]/g, '');